import { render, staticRenderFns } from "./Expenses.vue?vue&type=template&id=00da9f8c&scoped=true"
import script from "./Expenses.vue?vue&type=script&lang=js"
export * from "./Expenses.vue?vue&type=script&lang=js"
import style0 from "./Expenses.vue?vue&type=style&index=0&id=00da9f8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00da9f8c",
  null
  
)

export default component.exports